import { render, staticRenderFns } from "./licenceDetails.vue?vue&type=template&id=72cb3c64&scoped=true&"
import script from "./licenceDetails.vue?vue&type=script&lang=js&"
export * from "./licenceDetails.vue?vue&type=script&lang=js&"
import style0 from "./licenceDetails.vue?vue&type=style&index=0&id=72cb3c64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb3c64",
  null
  
)

export default component.exports